export const stockOptionsMpvIds = {
  'en-US': [
    'matteBusinessCards',
    'glossyBusinessCards',
    'embossedGlossBusinessCards',
    'uncoatedBusinessCards',
    'whitePlasticBusinessCards',
    'premiumPlusBusinessCards',
    'softTouchBusinessCards',
    'foilAccentBusinessCards',
    'paintedEdgeBusinessCards',
    'ultraThickBusinessCards',
    'frostedAndClearBusinessCards',
    'plasticBusinessCards',
    'pearlBusinessCards',
    'naturalTexturedBusinessCards',
    'linenBusinessCards',
    'raisedFoilBusinessCards',
    'recycledMatteBusinessCards',
    'kraftBusinessCards',
    'hempBusinessCards',
    'bambooBusinessCards',
    'cottonBusinessCards',
    'fineGritBusinessCards',
  ],
  'es-US': [
    'matteBusinessCards',
    'glossyBusinessCards',
    'embossedGlossBusinessCards',
    'uncoatedBusinessCards',
    'whitePlasticBusinessCards',
    'premiumPlusBusinessCards',
    'softTouchBusinessCards',
    'foilAccentBusinessCards',
    'paintedEdgeBusinessCards',
    'ultraThickBusinessCards',
    'frostedAndClearBusinessCards',
    'plasticBusinessCards',
    'pearlBusinessCards',
    'naturalTexturedBusinessCards',
    'linenBusinessCards',
    'raisedFoilBusinessCards',
    'recycledMatteBusinessCards',
    'kraftBusinessCards',
    'hempBusinessCards',
    'bambooBusinessCards',
    'cottonBusinessCards',
    'fineGritBusinessCards',
  ],
  'en-GB': [
    'matteBusinessCards',
    'glossyBusinessCards',
    'spotUVBusinessCards',
    'softTouchBusinessCards',
    'metallicBusinessCards',
    'raisedFoilBusinessCards',
    'pearlBusinessCards',
    'linenBusinessCards',
    'kraftBusinessCards',
    'naturalUncoatedBusinessCards',
    'texturedUncoatedBusinessCards',
    'cottonBusinessCards',
    'hempBusinessCards',
    'bambooBusinessCards',
    'recycledMatteBusinessCards',
    'tripleLayerBusinessCards',
    'plasticBusinessCards',
    'ultraThickBusinessCards',
    'letterpressBusinessCards',
    'durableBusinessCards',
  ],
}
export const BUSINESS_CARDS_STOCK_OPTIONS_SUPPORTED_MC_IDS = ['businessCards']

export const BUSINESS_CARDS_STOCK_OPTIONS_SUPPORTED_LOCALES = ['en-US', 'es-US']
